function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(16129 -1670)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  transform: "translate(-16129 1670)",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-17258.078 5078.998)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1147.136-3379.111q-3.471,0-6.943,0a2.886,2.886,0,0,1-3.106-3.113c0-2.248.022-4.5-.008-6.743a2.9,2.9,0,0,1,3.013-3.007c.3.013.609-.069.911-.052.359.02.412-.149.409-.454-.012-1.263-.006-2.527-.005-3.791a5.649,5.649,0,0,1,3.839-5.417,5.745,5.745,0,0,1,7.37,3.874,5.58,5.58,0,0,1,.165,1.3c.021,1.356.016,2.713,0,4.07,0,.362.116.483.484.486a7.628,7.628,0,0,1,1.815.134,2.759,2.759,0,0,1,2.047,2.682q.021,3.591,0,7.182a2.855,2.855,0,0,1-2.93,2.847C1151.844-3379.1,1149.49-3379.111,1147.136-3379.111Zm-.025-11.471c-2.354,0-4.708-.005-7.062,0a1.459,1.459,0,0,0-1.6,1.582c-.011.785,0,1.569,0,2.354,0,1.6-.007,3.192.012,4.787a1.326,1.326,0,0,0,1.342,1.385c1.262.034,2.526.038,3.788.039q5.147.007,10.293,0a1.988,1.988,0,0,0,1.331-.3,1.713,1.713,0,0,0,.572-1.466q.014-3.312,0-6.623a1.545,1.545,0,0,0-1.773-1.755Q1150.562-3390.584,1147.11-3390.581Zm.01-1.341c1.316,0,2.633-.005,3.949,0,.263,0,.384-.057.381-.353-.013-1.356.018-2.713-.012-4.069a4.316,4.316,0,0,0-4.387-4.285,4.339,4.339,0,0,0-4.285,4.35c-.011,1.3.01,2.606-.01,3.909-.005.356.11.454.455.449C1144.514-3391.933,1145.817-3391.922,1147.12-3391.922Z",
  fill: "currentColor",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1219.11-3274.074c0-.465-.007-.93,0-1.4a.644.644,0,0,1,.59-.719.663.663,0,0,1,.748.618c.031,1.022.027,2.046,0,3.068-.008.338-.3.5-.7.479a.579.579,0,0,1-.631-.576c-.019-.491,0-.983,0-1.475Z",
  transform: "translate(-72.679 -111.467)",
  fill: "currentColor",
  fillRule: "evenodd"
})));

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.85ee5ca8.svg";
export { ForwardRef as ReactComponent };